import cn from 'classnames';
import React from 'react';
import { primaryPalette } from '@tcl-argon-colors/colors';
import { Success } from '@tcl-argon-icons/icons';
import { mergeClasses } from '@tcl-argon-utils/utils';
import { useLoaderStyles } from './styles';
import { LoaderProps } from './types';
import './keyframes.scss';

const Loader: React.FC<LoaderProps> = ({
  classes: classOverrides,
  className,
  isComplete = false,
  color = primaryPalette.tempusPrimary,
  scale = 1,
  ...props
}) => {
  const classes = mergeClasses(useLoaderStyles({ scale, color }), classOverrides, { root: className });

  return (
    <div
      className={cn(classes.root, {
        [classes.spinner]: !isComplete,
      })}
      data-analytics="loader"
      {...props}
    >
      {isComplete && <Success className={classes.checkSvg} />}
    </div>
  );
};

export default Loader;
